module.exports = __webpack_public_path__ + "img/inicio-min.2f742eeb.png";